<div class="notification-item">
  <!-- customers name list -->
  <div class="flex items-center gap-1">
    <!-- un read point -->
    @if (!notificationData()?.seen) {
      <span
        class="notification-item__unread-point"
        >
      </span>
    }
    <p class="notification-item__customer-name">
      {{ notificationData()?.customer?.title }}
    </p>
  </div>

  <!-- date -->
  @if (notificationData()?.date) {
    <p class="notification-item__date">
      {{ convertToJalaali(notificationData().date) }}
    </p>
  }
</div>
